module.exports = __webpack_public_path__ + "static/media/productsBcg.160fddff.jpeg";